import React from 'react';

const SvgProfileEmail = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14.75 4c.97 0 1.75.78 1.75 1.75v8c0 .97-.78 1.75-1.75 1.75h-10c-.97 0-1.75-.78-1.75-1.75v-8C3 4.78 3.78 4 4.75 4h10zM15 8.15L10.72 11c-.59.4-1.35.4-1.94 0L4.5 8.15v5.6c0 .14.11.25.25.25h10c.14 0 .25-.11.25-.25v-5.6zm-.25-2.65h-10a.25.25 0 00-.25.25v.6l5.11 3.4c.07.05.15.06.23.03l.05-.02L15 6.35v-.6a.25.25 0 00-.25-.25z" />
  </svg>
);

export default SvgProfileEmail;
